import axios from 'axios'

const getDefaultState = () => ({
    progressOverlay: false,       
    enterMarks: false,
    termTest: false,
    editViewTermReports: false,
    mainMenu: true,
    attendance: false,
    primaryColor: process.env.VUE_APP_THEME_COLOR_PRIMARY,
    colorDarken: process.env.VUE_APP_THEME_COLOR_DARKEN,
    schoolName: process.env.VUE_APP_THEME_SCHOOL,
    lessons: [],
    lessonSelected: {},
    academicYearId: '',
    academicYear: '',
    currentYear: '',
    currentTerm: '',
    students: [],
    table2Records: [],
    markSheetOverlay: false,
    markSheetLoading: false,
    markSheetStudentSelected: '',
    markSheetFormLevel: '',
    expandLessonOptions: false,
    mainMenuButton: false,        
    enterMarksRecordSelected: {},
    updatedTable2Record: {},
    errorMessage: '',
    modal: false,
    modalIcon: '',
    modalTitle: '',
    modalMessage: '',
    welcomeMessage: true,
    subjectStudentsRegistered: '-',
    subjectStudentsMarksEntered: '-',
    subjectStudentsTotal: '-',
    editViewTermReportsOverlay: false,
    editViewTermReportsLoading: false,
    editViewTermReportsExpand: false,
    editViewTermReportsTable2Records: [],
    editViewTermReportsStudentSubjects: [],
    editViewTermReportsSaveStatus: '',
    editViewTermReportsSaving: false,
    editViewTermReportsSaveError: false,
    editViewTermReportsSaved: false,
    formClasses: [],
    formClassesList: [],
    selectedFormClass: '',
    selectedStudentRecord: {},
    pagination: {},
    commentSheet: false,
    commentSheetEnterMarks: false,
    formTeacherComments: '',
    updatedTable1Record: {},
    formTeacherClass: '',
    bottomSheetModel: '',
    bottomSheetTitle: '',
    table1Records: [],
    overlayLessons: false,
    subjectWeightings: [],
    progressText: null,
    selectedTable2RecordIndex: -1, 
    termsAvailable: [],
    src: null,
    overlayReport: false,
    expandTerms: false,        
    dialogReport: false,   
    deanFormClasses: [],   
    participationPercentage: null,  
    markSheetMarksEntered: null,
    markSheetAdminSelectedClass: null, 
    markSheetClasses: [],
    markSheetClassesFilter: [],
    markSheetRecordsFilter: [],
    selectedFormLevel: null,
    codedComments: [],
})

export default{
    namespaced: true,
    state: getDefaultState(),
    getters: {
        getEnterMarks(state){
            return state.enterMarks
        },
        getEditViewTermReports(state){
            return state.editViewTermReports
        },
        getMainMenu(state){
            return state.mainMenu
        },
        getPrimaryColor(state){
            return state.primaryColor
        },
        getColorDarken(state){
            return state.colorDarken
        },
        getSchoolName(state){
            return state.schoolName
        },
        getLessons(state){
            return state.lessons
        },
        getLessonSelected(state){
            return state.lessonSelected
        },
        getAcademicYearId(state){
            return state.academicYearId
        },
        getAcademicYear(state){
            return state.academicYear
        },
        getCurrentYear(state){
            return state.currentYear
        },
        getCurrentTerm(state){
            return state.currentTerm
        },
        getStudents(state){
            return state.students
        },
        getMarkSheetOverlay(state){
            return state.markSheetOverlay
        },
        getTable2Records(state){
            return state.table2Records
        },
        getExpandLessonOptions(state){
            return state.expandLessonOptions
        },
        getMainMenuButton(state){
            return state.mainMenuButton
        },
        getMarkSheetLoading(state){
            return state.markSheetLoading
        },
        getEnterMarksRecordSelected(state){
            return state.enterMarksRecordSelected
        },
        getUpdatedTable2Record(state){
            return state.updatedTable2Record
        },
        getErrorMessage(state){
            return state.errorMessage
        },
        getModal(state){
            return state.modal
        },
        getModalIcon(state){
            return state.modalIcon
        },
        getModalTitle(state){
            return state.modalTitle
        },
        getModalMessage(state){
            return state.modalMessage
        },
        getWelcomeMessage(state){
            return state.welcomeMessage
        },
        getSubjectStudentsRegistered(state){
            return state.subjectStudentsRegistered
        },
        getSubjectStudentsMarksEntered(state){
            return state.subjectStudentsMarksEntered
        },
        getSubjectStudentsTotal(state){
            return state.subjectStudentsTotal
        },
        getMarkSheetStudentSelected(state){
            return state.markSheetStudentSelected
        },
        getMarkSheetFormLevel(state){
            return state.markSheetFormLevel
        },
        getEditViewTermReportsOverlay(state){
            return state.editViewTermReportsOverlay
        },
        getEditViewTermReportsLoading(state){
            return state.editViewTermReportsLoading
        },
        getEditViewTermReportsExpand(state){
            return state.editViewTermReportsExpand
        },
        getFormClasses(state){
            return state.formClasses
        },
        getFormClassesList(state){
            return state.formClassesList
        },
        getSelectedFormClass(state){
            return state.selectedFormClass
        },
        getSelectedStudentRecord(state){
            return state.selectedStudentRecord
        },
        getPagination(state){
            return state.pagination
        },
        getCommentSheet(state){
            return state.commentSheet
        },

        getCommentSheetEnterMarks (state) {
            return state.commentSheetEnterMarks
        },
        
        getFormTeacherComments(state){
            return state.formTeacherComments
        },
        getEditViewTermReportsTable2Records(state){
            return state.editViewTermReportsTable2Records
        },
        getEditViewTermReportsStudentSubjects (state) {
            return state.editViewTermReportsStudentSubjects
        },
        getUpdatedTable1Record(state){
            return state.updatedTable1Record
        },
        getEditViewTermReportsSaveStatus(state){
            return state.editViewTermReportsSaveStatus
        },
        getEditViewTermReportsSaving(state){
            return state.editViewTermReportsSaving
        },
        getEditViewTermReportsSaveError(state){
            return state.editViewTermReportsSaveError
        },
        getEditViewTermReportsSaved(state){
            return state.editViewTermReportsSaved
        },
        getFormTeacherClass(state){
            return state.formTeacherClass
        },
        getProgressOverlay(state){
            return state.progressOverlay
        },
        getBottomSheetModel(state){
            return state.bottomSheetModel
        },
        getBottomSheetTitle(state){
            return state.bottomSheetTitle
        },
        getTable1Records(state){
            return state.table1Records
        },
        getOverlayLessons(state){
            return state.overlayLessons
        },

        getSubjectWeightings (state) {
            return state.subjectWeightings
        },

        getProgressText (state) {
            return state.progressText
        },

        getSelectedTable2RecordIndex (state) {
            return state.selectedTable2RecordIndex
        },

        getTermsAvailable (state) {
            return state.termsAvailable
        },

        getSrc (state) {
            return state.src
        },

        getOverlayReport (state) {
            return state.overlayReport
        },

        getExpandTerms (state) {
            return state.expandTerms
        },       
        
        getDialogReport (state) {
            return state.dialogReport
        },

        getDeanFormClasses (state) {
            return state.deanFormClasses
        },

        getTermTest (state) {
            return state.termTest
        },

        getParticipationPercentage (state) {
            return state.participationPercentage
        },

        getMarkSheetMarksEntered(state) {
            return state.markSheetMarksEntered
        },

        getMarkSheetAdminSelectedClass (state) {
            return state.markSheetAdminSelectedClass
        },

        getMarkSheetClasses (state) {
            return state.markSheetClasses
        },

        getMarkSheetClassesFilter (state) {
            return state.markSheetClassesFilter
        },

        getMarkSheetRecordsFilter (state) {
            return state.markSheetRecordsFilter
        },

        getSelectedFormLevel (state) {
            return state.selectedFormLevel
        },

        getCodedComments (state) {
            return state.codedComments
        },

        getAttendance (state) {
            return state.attendance
        }

        
    },

    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())  
        },
        setEnterMarks(state, value){
            state.enterMarks = value
        },
        setEditViewTermReports(state, value){
            state.editViewTermReports = value
        },
        setMainMenu(state, value){
            state.mainMenu = value
        },
        setLessons(state, value){
            state.lessons = value
        },
        setLessonSelected(state, value){
            state.lessonSelected = value
        },
        setAcademicYearId(state, value){
            state.academicYearId = value
        },
        setAcademicYear(state, value){
            state.academicYear = value
        },
        setCurrentYear(state, value){
            state.currentYear = value
        },
        setCurrentTerm(state, value){
            state.currentTerm = value
        },
        setStudents(state, value){
            state.students = value
        },
        setMarkSheetOverlay(state, value){
            state.markSheetOverlay = value
        },
        setTable2Records(state, value){
            state.table2Records = value
        },
        setExpandLessonOptions(state, value){
            state.expandLessonOptions = value
        },
        setMainMenuButton(state, value){
            state.mainMenuButton = value
        },
        setMarkSheetLoading(state, value){
            state.markSheetLoading = value
        },
        setCodedComments(state, value){
            state.codedComments = value
        },
        setEnterMarksRecordSelected(state, value){
            state.enterMarksRecordSelected = value
        },
        setUpdatedTable2Record(state, value){
            state.updatedTable2Record = value
        },
        setErrorMessage(state, value){
            state.errorMessage = value
        },
        setModal(state, value){
            state.modal = value
        },
        setModalTitle(state, value){
            state.modalTitle = value
        },
        setModalIcon(state, value){
            state.modalIcon = value
        },
        setModalMessage(state, value){
            state.modalMessage = value
        },
        setWelcomeMessage(state, value){
            state.welcomeMessage = value
        },
        setSubjectStudentsTotal(state, value){
            state.subjectStudentsTotal = value
        },
        setSubjectStudentsRegistered(state, value){
            state.subjectStudentsRegistered = value
        },
        setSubjectStudentsMarksEntered(state, value){
            state.subjectStudentsMarksEntered = value
        },
        setMarkSheetStudentSelected(state, value){
            state.markSheetStudentSelected = value
        },
        setMarkSheetFormLevel(state, value){
            state.markSheetFormLevel = value
        },
        setEditViewTermReportsOverlay(state, value){
            state.editViewTermReportsOverlay = value
        },
        setEditViewTermReportsLoading(state, value){
            state.editViewTermReportsLoading = value
        },
        setEditViewTermReportsExpand(state, value){
            state.editViewTermReportsExpand = value
        },
        setFormClasses(state, value){
            state.formClasses = value
        },
        setFormClassesList(state, value){
            state.formClassesList = value
        },
        setSelectedFormClass(state, value){
            state.selectedFormClass = value
        },
        setSelectedStudentRecord(state, value){
            state.selectedStudentRecord = value
        },
        setPagination(state, value){
            state.pagination = value
        },
        setCommentSheet(state, value){
            state.commentSheet = value
        },

        setCommentSheetEnterMarks (state, value) {
            state.commentSheetEnterMarks = value
        },

        setFormTeacherComments(state, value){
            state.formTeacherComments = value
        },
        setEditViewTermReportsTable2Records(state, value){
            state.editViewTermReportsTable2Records = value
        },
        setEditViewTermReportsStudentSubjects(state, value){
            state.editViewTermReportsStudentSubjects = value
        },
        setUpdatedTable1Record(state, value){
            state.updatedTable1Record = value
        },
        setEditViewTermReportsSaveStatus(state, value){
            state.editViewTermReportsSaveStatus = value
        },
        setEditViewTermReportsSaving(state, value){
            state.editViewTermReportsSaving = value
        },
        setEditViewTermReportsSaveError(state, value){
            state.editViewTermReportsSaveError = value
        },
        setEditViewTermReportsSaved(state,value){
            state.editViewTermReportsSaved = value
        },
        setFormTeacherClass(state, value){
            state.formTeacherClass = value
        },
        setProgressOverlay(state, value){
            state.progressOverlay = value
        },
        setBottomSheetModel(state, value){
            state.bottomSheetModel = value
        },
        setBottomSheetTitle(state, value){
            state.bottomSheetTitle = value
        },
        setTable1Records(state, value){
            state.table1Records = value
        },
        setOverlayLessons(state, value){
            state.overlayLessons = value
        },
        setSubjectWeightings(state, value){
            state.subjectWeightings = value
        },

        setProgressText (state, value) {
            state.progressText = value
        },

        setSelectedTable2RecordIndex (state, value) {
            state.selectedTable2RecordIndex = value
        },

        setTermsAvailable (state, value) {
            state.termsAvailable = value
        },

        setExpandTerms (state, value) {
            state.expandTerms = value
        },                

        setDialogReport (state, value) {
            state.dialogReport = value
        },

        setSrc (state, value) {
            state.src = value
        },

        setOverlayReport (state, value) {
            state.overlayReport = value
        },

        setDeanFormClasses (state, value) {
            state.deanFormClasses = value
        },

        setTermTest (state, value) {
            state.termTest = value
        },

        setParticipationPercentage (state, value) {
            state.participationPercentage = value
        },

        setMarkSheetMarksEntered (state, value) {
            state.markSheetMarksEntered = value
        },

        setMarkSheetAdminSelectedClass (state, value) {
            state.markSheetAdminSelectedClass = value
        },

        setMarkSheetClasses (state, value) {
            state.markSheetClasses = value
        },

        setMarkSheetClassesFilter (state, value) {
            state.markSheetClassesFilter = value
        },

        setMarkSheetRecordsFilter (state, value) {
            state.markSheetRecordsFilter = value
        },

        setSelectedFormLevel (state, value) {
            state.selectedFormLevel = value
        },

        setAttendance (state, value) {
            state.attendance = value
        }
       
    },

    actions: {
        async getLessons({ getters }, id){
            const url = '/api/teacher-lessons';
            return axios.get(url, {
                params: {
                    employee_id: id,
                    academic_year_id:  getters.getAcademicYearId
                }
            });
        },

        async getCurrentAcademicPeriod({ commit }){
            let url = '/api/current-period';
            try {
                let response = await axios.get(url);
                const data = response.data;
                // console.log(data);
                const { current_term } = data;
                let academicYear = current_term.academic_year_id;
                commit('setAcademicYearId', academicYear);
                commit('setAcademicYear', academicYear.toString().substr(0, 4) + '-' + academicYear.toString().substr(4))
                commit('setCurrentYear', academicYear.toString().substr(0,4));
                commit('setCurrentTerm', current_term.term);
            } catch (error) {
                console.log(error);
            }
        },

        async getStudents({ commit, getters, dispatch }, id){
            //console.log('getting students..')
            commit('setProgressText', 'Getting Students..');
            
            let params = {
                employee_id: id,
                subject_id: getters.getLessonSelected.subjectCode,
                class_id: getters.getLessonSelected.classId,
                form_classes: getters.getLessonSelected.form_classes,
                year: getters.getCurrentYear,
                term: getters.getCurrentTerm,
                form_level: getters.getLessonSelected.formLevel
            }

            const url = '/api/teacher-lesson-students'

            try {
                const { data } = await axios.get(url, { params });
                
                commit('setProgressText', 'Setting up Mark Sheet..');
                dispatch('setTable2Records', data.data);                
                commit('setSubjectStudentsTotal', data.total);
                commit('setSubjectStudentsRegistered', data.registered);
                commit('setSubjectStudentsMarksEntered', data.entered);
                commit('setSubjectWeightings', data.weightings);
            } catch (error) {
                if(error.response) console.log(error.response)
                else console.log(error);
                commit('setExpandLessonOptions', true);
                commit('setModalTitle', 'Error Occured.');
                commit('setModalIcon', 'error');
                commit('setModalMessage', error.response.statusText);
                commit('setModal', true);
            }

            commit('setProgressText', '');
            commit('setMarkSheetLoading', false);
            commit('setMarkSheetOverlay', false);
        },

        saveTable2Record({ getters }){
            const url = '/api/table2';
            return axios.post(url, getters.getUpdatedTable2Record);
        },

        getTable1Record({ getters }, page_url){
            //let vm = this;
            const url = '/api/students-registered'

            page_url = page_url || url;

            return axios.get(page_url, {
                params: {
                    year: getters.getCurrentYear,
                    term: getters.getCurrentTerm,
                    class_id: getters.getSelectedFormClass,
                }
            });
           
        },
        
        getTable2Records({ getters }){
            const url = '/api/student-table2-records'

            return axios.get(url, {
                params: {
                    student_id: getters.getSelectedStudentRecord.student_id,
                    year: getters.getCurrentYear,
                    term: getters.getCurrentTerm,
                    class_id: getters.getSelectedStudentRecord.class_id,
                }
            });
        },
                
        getFormClasses(){
            const url = '/api/form-classes';
            return axios.get(url)
        },
        
        setErrorResponse({ commit },error){
            console.log(error.response);
            if(error.response){                
                commit('setModalTitle', 'Error Occured.');
                commit('setModalIcon', 'error');
                commit('setModalMessage', error.response.data.message);
                commit('setModal', true);
            }
            else{
                commit('setModalTitle', 'Error Occured.');
                commit('setModalIcon', 'error');
                commit('setModalMessage', 'An Error Occured Please contact your administrator');
                commit('setModal', true);
            }
        },
        setTable2Records({ commit }, records){
            let table2Records = [];
            let count = 0;                         
            records.forEach(record =>{
                let studentRecord = {};
                studentRecord.count = ++count;
                studentRecord.name = record.last_name + ', ' + record.first_name;                                            
                studentRecord = Object.assign(studentRecord, record);
                table2Records.push(studentRecord);                    
            })
            // console.log(table2Records)
            commit('setTable2Records', table2Records);
            //console.log(getters.termMarksRecords);
        },
        async postTable1Record({ getters }){
            const url = "/api/table1";
            return axios.post(url, getters.getSelectedStudentRecord);
        },

        getAssignedFormTeacherClass({ getters }, id){
            const url = '/api/form-teacher-class'; 
            const params = {
                id: id,
                year: getters.getAcademicYearId
            }
            return axios.get(url, {
                params
            });
        },
        
        dowloadExcelMarkSheet ({ getters }) {
            let url = getters.getSrc.baseUrl + "-excel";  
            let currKey = null;
            let prevKey = null;
            let keyCount = 0;
            
            Object.keys(getters.getSrc).forEach((key) => {
                currKey = key;
                if(key == "report" || key == "baseUrl"){
                    prevKey = currKey;
                    return;
                } 

                keyCount++;

                if(keyCount == 1){
                    url += `?${key}=${getters.getSrc[key]}`;
                    prevKey = currKey;
                    return;
                }

                if(prevKey && prevKey != currKey){
                    url += `&${key}=${getters.getSrc[key]}`;
                    return;
                }
                prevKey = currKey;
            })  
            
            console.log(url)
            
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        downloadAcademicHistory ({ getters }) {
            let url = getters.getSrc.baseUrl;  
            let currKey = null;
            let prevKey = null;
            let keyCount = 0;
            
            Object.keys(getters.getSrc).forEach((key) => {
                currKey = key;
                if(key == "report" || key == "baseUrl"){
                    prevKey = currKey;
                    return;
                } 

                keyCount++;

                if(keyCount == 1){
                    url += `?${key}=${getters.getSrc[key]}`;
                    prevKey = currKey;
                    return;
                }

                if(prevKey && prevKey != currKey){
                    url += `&${key}=${getters.getSrc[key]}`;
                    return;
                }
                prevKey = currKey;
            })  
            
            // console.log(url)
            
            return axios({
                method: 'get',
                url: url,
                responseType: 'arraybuffer',
            });
        },

        getDeanFormClasses ({ rootGetters, getters }){
            const url = 'api/dean-form-classes';
            const params = {
                employeeId: rootGetters['auth/getEmployeeId'],
                academicYearId: getters.getAcademicYearId
            }
            
            return axios.get(url, {
                params 
            });
        },

        getSubjects(){
            let url = 'api/subjects';
            return axios.get(url);
        },

        getCoCurriculars(){
            const url = 'api/co-curriculars';
            return axios.get(url);
        },

        getMusicClasses ({ rootGetters }) {
            const url = 'api/music-classes';
            return axios.get(url, { params: { employee_id: rootGetters['auth/getEmployeeId'] } });
        },

        getClassesChangeClass () {
            const url = 'api/form-classes-change-class';
            return axios.get(url);
        },

        getCodedComments () {
            const url = 'api/coded-comments';
            return axios.get(url);
        }

        
    }
}    